import { FormattedMessage } from "react-intl";

import AccountCreation from "@/components/signup/account-creation";
import { SignupBackgroundLayout } from "@/components/signup/layouts";
import { ProductKey, TeamworkCollectionLogo } from "@/components/signup/utils";
import { useLocation } from "@/utils/location-provider";

import { GetStartedHeading, Heading, SubHeading } from "../../components";

export const LoggedOut = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const primaryCollectionProduct = params.get("primaryCollectionProduct");
    let heading = <GetStartedHeading productName="Teamwork Collection" />;
    let subheading = {
        id: "signup.teamworkCollection.subHeading",
        defaultMessage: "It’s free for up to 10 users - no credit card needed."
    };

    if (primaryCollectionProduct === ProductKey.ROVO) {
        heading = (
            <Heading>
                <FormattedMessage
                    id="signup.teamworkCollection.rovoHeading"
                    defaultMessage="Get Teamwork Collection to start using Rovo"
                />
            </Heading>
        );
        subheading = {
            id: "signup.teamworkCollection.rovoSubHeading",
            defaultMessage:
                "Free for up to ten users. Start using Rovo in 20 minutes or less after sign-up."
        };
    }

    return (
        <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
            {heading}
            <SubHeading>
                <FormattedMessage {...subheading} />
            </SubHeading>
            <AccountCreation />
        </SignupBackgroundLayout>
    );
};
